"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EyeHide = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var helios_styles_1 = require("@carvana/helios-styles");
var EyeHide = function (_a) {
    var _b = _a.color, color = _b === void 0 ? helios_styles_1.icon.default : _b;
    return ((0, jsx_runtime_1.jsxs)("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", fill: "none" }, { children: [(0, jsx_runtime_1.jsx)("path", { fill: color, fillRule: "evenodd", d: "M4.47 1.47a.75.75 0 0 1 1.06 0l10 10a.75.75 0 1 1-1.06 1.06l-1.023-1.022c-1.498 1.357-3.37 2.18-5.416 2.18-3.07 0-5.727-1.844-7.354-4.566a2.268 2.268 0 0 1 0-2.335C1.709 5.061 3.15 3.69 4.855 2.916L4.47 2.53a.75.75 0 0 1 0-1.06Zm6.186 7.246 1.729 1.73c-1.25 1.11-2.753 1.743-4.354 1.743-2.426 0-4.645-1.458-6.067-3.837a.768.768 0 0 1 0-.795c.97-1.622 2.316-2.82 3.838-3.413a.75.75 0 0 0 .18-.101l1.302 1.301a2.751 2.751 0 1 0 3.372 3.372ZM6.75 8a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Z", clipRule: "evenodd" }), (0, jsx_runtime_1.jsx)("path", { fill: color, d: "M9.473 3.084a.75.75 0 0 1 .947-.476c2.048.678 3.778 2.193 4.965 4.18.328.548.408 1.196.235 1.794a.75.75 0 0 1-1.441-.416.767.767 0 0 0-.081-.609c-1.036-1.732-2.5-2.98-4.15-3.526a.75.75 0 0 1-.475-.947Z" })] })));
};
exports.EyeHide = EyeHide;
